import Component from '../../../shared/component';

export default class AssetModalTrigger extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);
    this.$modal = opts.assetModal;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.AssetModalTrigger', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.AssetModalTrigger', this.handleClick);
  }

  handleClick() {
    this.$modal.fetchData(this.$element.data('resource-url'));
  }
}
